import Vue from "vue";
import { navRouterMap } from "@/router";
import { filterNavRouters } from "@/utils/routerPermission";
import Cookies from "js-cookie";
import _ from "lodash";

const mutations = {
  windowHandle: (state, value) => {
    state.popup.appModal = true;
    switch (value) {
      case "addPopup":
        state.popup.addPopup = true;
        break;
      case "addChannelPopup":
        state.popup.addChannelPopup = true;
        break;
      case "addPopupImg":
        state.popup.addPopupImg = true;
        break;
      case "addBooks":
        state.popup.addBooks = true;
        break;
      case "addRootNodeBooks":
        state.popup.addRootNodeBooks = true;
        break;
      case "addEditRootNodeBooks":
        state.popup.addEditRootNodeBooks = true;
        break;
      case "delPopup":
        state.popup.delPopup = true;
        break;
      case "showAddBooksList":
        state.popup.showAddBooksList = true;
        break;
      case "showRefreshBooksList":
        state.popup.showRefreshBooksList = true;
        break;
      case "delFacility":
        state.popup.delFacility = true;
        break;
      case "appendPopup":
        state.popup.appendPopup = true;
        break;
      case "macPopup":
        state.popup.macPopup = true;
        break;
      case "showCreateOrg":
        state.popup.showCreateOrg = true;
        break;
      case "showPushChannel":
        state.popup.showPushChannel = true;
        break;
      case "showDateTimePicker":
        state.popup.showDateTimePicker = true;
        break;
      case "showAddBookList":
        state.popup.showAddBookList = true;
        break;
      case "showBatchUpload":
        state.popup.showBatchUpload = true;
        break;
      case "showClassifyEdit":
        state.popup.showClassifyEdit = true;
        break;
      case "showClassifyEditBoobsLis":
        state.popup.showClassifyEditBoobsLis = true;
        break;
      default:
        for (let item in state.popup) {
          state.popup[item] = false;
        }
    }
  },
  setBuckets: (state, buckets) => {
    state.buckets = buckets;
  },
  setBucketData: (state, bucketData) => {
    state.bucketData = bucketData;
  },
  SAVE_CATEGORIES: (state, data) => {
    state.categories = data;
  },
  SAVE_CHANNELS: (state, data) => {
    state.channels = data.rows;
  },
  navCtrl: (state) => {
    state.navCtrl = !state.navCtrl;
  },
  USER_INFO: (state, data) => {
    state.userInfo = data;
  },
  SAVE_HAS_DATA: (state, data) => {
    state.hasData = data;
  },

  SET_ROUTER: (state, data) => {
    state.userRouters = data;
    if (data.length === 0) return;
    state.routers = filterNavRouters(navRouterMap, data, state.userInfo);
  },
  CLEAR_ROUTER: (state) => {
    state.routers = [];
  },
  SET_SELECT_SHOW: (state, val) => {
    state.selectShow = val;
    // console.error('val----:', val)
  },
  SET_OVERALL_SHOW: (state, show) => {
    state.isSelectOverall = show;
  },
  SET_HANDLE_SHOW: (state, handle) => {
    state.isHandle = handle;
  },
  SET_LANG: (state, lang) => {
    state.language = lang;
    Cookies.set("language", lang);
  },
  // ============= cb信息反馈 ============
  MERGE_CB_MSG_LIST: (state, arr) => {
    let list = [...state.cbMsgList, ...arr];
    state.cbMsgList = _.orderBy(_.uniqBy(list, "uniqueId"), ["createdAt"]);
    console.log("pzz--MERGE_CB_MSG_LIST", state.cbMsgList);
  },
  UPDATE_CB_MSG_LIST: (state, list) => {
    state.cbMsgList = _.orderBy(_.uniqBy(list, "uniqueId"), ["createdAt"]);
    console.log("pzz--UPDATE_CB_MSG_LIST", state.cbMsgList);
  },
  UPDATE_CB_USER_LIST: (state, list) => {
    state.cbUserList = list;
  },

  SET_CB_CURRENT_USER: (state, item) => {
    state.cbCurrentUser = item;
  },
  // ============= cb 发件箱（消息级发送状态，不进 db 文档，避免同步污染） =============
  // 结构: { [uniqueId]: 'sending' | 'fail' }，undefined 表示已发送
  // Vue2.7 动态属性增删需用 Vue.set/Vue.delete 才能保持响应式
  ADD_CB_OUTBOX: (state, { id, st = "sending" }) => {
    Vue.set(state.cbOutbox, id, st);
    localStorage.setItem("cb_outbox", JSON.stringify(state.cbOutbox));
  },
  SET_CB_OUTBOX: (state, { id, st }) => {
    Vue.set(state.cbOutbox, id, st);
    localStorage.setItem("cb_outbox", JSON.stringify(state.cbOutbox));
  },
  REMOVE_CB_OUTBOX: (state, id) => {
    Vue.delete(state.cbOutbox, id);
    localStorage.setItem("cb_outbox", JSON.stringify(state.cbOutbox));
  },
};

export default mutations;
